export function capitalizeFirstLetter(str: string) {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}
export function largetalizeFirstLetter(str: string) {
  if (!str) return str;
  return str.charAt(0).toLowerCase() + str.slice(1);
}
